var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:down-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2068 8.7066C11.394 8.5191 11.4992 8.26493 11.4992 7.99993C11.4992 7.73493 11.394 7.48077 11.2068 7.29327L7.43609 3.52127C7.24849 3.33376 6.99409 3.22845 6.72885 3.22852C6.46361 3.22858 6.20926 3.334 6.02176 3.5216C5.83425 3.7092 5.72894 3.9636 5.729 4.22884C5.72907 4.49408 5.83449 4.74843 6.02209 4.93593L9.08609 7.99993L6.02209 11.0639C5.83984 11.2524 5.73892 11.505 5.74108 11.7672C5.74323 12.0294 5.84828 12.2803 6.0336 12.4658C6.21893 12.6513 6.46969 12.7565 6.73189 12.7589C6.99408 12.7613 7.24673 12.6607 7.43542 12.4786L11.2074 8.70727L11.2068 8.7066Z",
    fill: "#0A3B70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFill);
export default __webpack_public_path__ + "static/media/Download-Fill.029b5c5f291765b77d0b89f1de86e9e1.svg";
export { ForwardRef as ReactComponent };